<template>
  <div>
    <div class="info-layout">
      <h3>
        Change password
      </h3>
    </div>
    <div class="input-group">
      <dg-input type="password" v-model="formData.currentPassword" placeholder="Current password" icon="lock-open" :error="errors.currentPassword" fa />
      <dg-input type="password" v-model="formData.password" placeholder="New password" icon="lock" :error="errors.password" fa />
      <dg-input type="password" v-model="formData.confirmPassword" placeholder="confirm new password" icon="lock" :error="errors.confirmpassword" fa />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecurityDetails',
  props: {
    errors: Object
  },
  watch: {
    formData: {
      handler () {
        this.$emit('change', this.formData)
      },
      deep: true
    }
  },
  data () {
    return {
      formData: {
        currentPassword: '',
        password: '',
        confirmPassword: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .info-layout {
    padding: 20px 0px 20px 0px;

    h3 {
      padding: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/profile/SecurityDetails.vue